<template>    
    <!-- eslint-disable -->
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a>
                    <router-link :to="{name:'r-/'}">Inicio</router-link>
                </a></li>
                <li class="breadcrumb-item active" aria-current="page">Usuarios</li>
            </ol>
        </nav>
        <div>
            <div class="row">
                <div class="col-12 mt-4">
                    <div class="card">
                        <div class="card-body" style="display:flex; flex-wrap: wrap;">
                            <div style="width: 100%; display:flex; justify-content:center;">
                                <button type="button" class="boton-3d-success" @click=boton_modal_registro>
                                    Nuevo usuario
                                </button>
                            </div>         
                            <div v-if="datos.data_table.cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:white;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>    
                            <div id="contenedor-tabla-registros" style="width: 100%;"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade bd-example-modal-lg" id="modal-registro">
            <div class="modal-dialog modal-lg">
                <div class="modal-content modal-3d">
                    <div class="modal-header">
                        <h5 v-if="datos.registro.id===''" class="modal-title">Crear usuario</h5>
                        <h5 v-else class="modal-title">Editar usuario</h5>
                        <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div class="form-row">  
                                <div class="form-group col-md-4">
                                    <label for="inputEmail4">Rol</label>
                                    <select class="form-control input-3d" v-model=datos.registro.rol>
                                        <option value="" disabled>Seleccione</option>
                                        <option value="administrador">Administrador</option>
                                        <!-- <option value="caja">Caja</option>
                                        <option value="cargador">Cargador</option> -->
                                    </select>
                                </div>
                            
                                <div class="form-group col-md-4">
                                    <label for="inputEmail4">Nombre</label>
                                    <input type="text" class="form-control input-3d" v-model=datos.registro.nombre>
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="inputEmail4">Apellido Paterno</label>
                                    <input type="text" class="form-control input-3d" v-model=datos.registro.apellido_paterno>
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="inputEmail4">Apellido Materno</label>
                                    <input type="text" class="form-control input-3d" v-model=datos.registro.apellido_materno>
                                </div>

                                <template v-if="['administrador','caja'].includes(datos.registro.rol)">
                                    <div class="form-group col-md-4">
                                        <label for="inputEmail4">Correo</label>
                                        <input type="text" class="form-control input-3d" v-model=datos.registro.email>
                                    </div>
                                    
                                    <div class="form-group col-md-4">
                                        <label for="inputEmail4">Contraseña</label>
                                        <input type="text" class="form-control input-3d" v-model=datos.registro.password>
                                    </div>
                                </template>

                                <!-- <div class="form-group col-md-4">
                                    <label for="inputEmail4">Sueldo</label>
                                    <input type="number" class="form-control input-3d" v-model=datos.registro.sueldo>
                                </div> -->
                            </div>                              
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button v-if="datos.registro.id=='' " type="button" class="boton-3d-success" @click="enviar_datos">Crear</button>
                        <button v-if="datos.registro.id!=='' " type="button" class="boton-3d-success" @click="enviar_datos">Editar</button>
                        <button type="button" class="boton-3d-danger" data-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
/* eslint-disable */ 
import { mapState } from 'vuex'
import { mapMutations } from 'vuex'
import Swal   from '@/librerias/sweetalert2_9/sweetalert2_9.js'
import * as calculos  from '@/librerias/lobato-calculos.js'

export default {
  name: 'com_general',
  props: {
    msg: String
  },
  data() {
    return {
        datos:{
            registro:{
                id:'',
                nombre:'',
                apellido_paterno:'',
                apellido_materno:'',
                email:'',
                //telefono:'',
                password:'',
                rol:'',
                //sueldo:''
            },
            data_table:{
                datos:[],
                cargando:false
            },
            num_soc:{
                verificando_num_soc:false,
                existe:''
            }
        }
    }
  },
  mounted(){
    this.inicial();
  },
  methods:{
    ...mapMutations(['funciones','alerta']), 
    inicial()   
        {
            if(this.general.otros.autenticado===true)
            {
                //this.obtener_recursos();
                //this.data_table();
                this.obtener_datos_data_table();
            }
            else if(this.general.otros.autenticado===false)
            {
                console.log('here 1');
                this.$router.push('/login');
            }
        },
        obtener_recursos()
        {
            let clientes={
                parametros:{
                    campos:["id","nombre_comercial "],
                    orderby:['nombre_comercial','asc']
                }
            };
            this.clientes_todos(clientes);
        },
        boton_modal_registro()
        {
            for (const property in this.datos.registro) {
                if(property=='pruebas')
                {
                    for (const prueba in this.datos.registro.pruebas) {
                        this.datos.registro.pruebas[prueba]='';
                    }
                }
                else if(property=='piezas')
                {
                    this.datos.registro.piezas=[];
                }
                else if(property=='imagenes')
                {
                    this.datos.registro.imagenes=[];
                }
                else
                {
                    this.datos.registro[property]='' ; 
                }
            }
            this.datos.num_soc.verificando_num_soc=false;
            this.datos.num_soc.existe='';
            this.funciones({nombre:'sonido',sonido:this.general.sonidos.abrir});
            $("#modal-registro").modal("show");
            //console.log('clientes5');
            //console.log(this.general.clientes.todos);
        },
        obtener_datos_data_table()
        {
            this.datos.data_table.cargando=true;
            fetch(`${this.general.otros.dominio_server}/usuarios/todos`,{
                method:'POST',
                body:JSON.stringify( this.datos.registro ),
                headers:{
                    'Accept': 'application/json',
                    'Content-Type'  :'application/json',
                    //'Authorization' : `Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },
                credentials: 'include',
            })
            .then(res=>res.json())
            .then(respuesta=>{
                this.datos.data_table.datos=respuesta.data;    
                this.data_table();         
            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los usuarios`});
            })
            .finally( () => {
                this.datos.data_table.cargando=false;                
            });
        },
        data_table()
        {
            document.getElementById('contenedor-tabla-registros').innerHTML=`
                <table id="tabla-registros" class="table table-hover w-100 pb-30">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Nombre</th>
                            <th>Estado</th>
                            <th>Rol</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody >
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>Id</th>
                            <th>Nombre</th>
                            <th>Estado</th>
                            <th>Rol</th>
                            <th>Acciones</th>
                        </tr>
                    </tfoot>
                </table>
            `;

            $('#tabla-registros thead tr').clone(true).appendTo( '#tabla-registros thead' );
            $('#tabla-registros thead tr:eq(1) th').each( function (i) {
                var title = $(this).text();
                $(this).html( '<input class="form-control" style="width:100%;font-size:11px;" type="text" placeholder="Buscar '+title+'" />' );
        
                $( 'input', this ).on( 'keyup change', function () {
                    if ( tabla_registros.column(i).search() !== this.value ) {
                        tabla_registros
                            .column(i)
                            .search( this.value )
                            .draw();
                    }
                } );
            } );
            var tabla_registros=$('#tabla-registros').DataTable({
                orderCellsTop: true,
                fixedHeader: true,
                responsive: true,
                autoWidth: true,
                "order":[1,'asc'],
                language: {
                    search: "Buscar",
                    searchPlaceholder: "Buscar",
                    lengthMenu: "Mostrando _MENU_ registros por página",
                    zeroRecords: "No se encontraron registros",
                    info: "Mostrando pagina _PAGE_ de _PAGES_",
                    infoEmpty: "No hay registros disponibles",
                    infoFiltered: "(filtrando de _MAX_ registros)",
                    paginate: {
                        "first":      "First",
                        "last":       "Last",
                        next:       "Siguiente",
                        previous:   "Anterior"
                    },
                },
                //ajax:`/ordenes_elaboracion_materiales/todos`,
                //ajax:`${this.general.otros.dominio}/usuarios/todos`,
                data:this.datos.data_table.datos,
                /*columns: [
                             { data: 'id'},
                    { data: 'nombre'},
                    { data: 'objetivo_general'},
                    { data: 'precio'}
                ],*/
                columnDefs:[
                    {"targets":0, "data":function(data,type,full,meta)
                        {
                            return data.id;
                        }
                    },
                    {"targets":1, "data":function(data,type,full,meta)
                        {
                            let a=`${data.nombre} ${data.apellido_paterno} ${data.apellido_materno}`;
                            return a;
                        }
                    },
                    {"targets":2, "data":function(data,type,full,meta)
                        {
                            return data.estado;
                        }
                    },
                    {"targets":3, "data":function(data,type,full,meta)
                        {
                            return data.rol;
                        }
                    },
                    {"targets":4, "data":(data,type,full,meta)=>
                        {
                            var acciones=``;

                            acciones+=`
                                <button registro-id='${data.id}' class="boton-modal-editar-registro boton-3d-info" style="margin-right:1em;">
                                    <i registro-id='${data.id}' class="fa fa-pencil-square-o" aria-hidden="true"></i>
                                    Editar
                                </button>
                                <button registro-id='${data.id}' class="boton-modal-remover boton-3d-danger" style="margin-right:1em;">
                                    <i registro-id='${data.id}' class='fa fa-times' aria-hidden='true'></i>                                    
                                </button>
                            `;

                            return `
                                <div style="display:flex; justify-content:left;">
                                    ${acciones} 
                                </div>
                            `;
                        }
                    }
                ],
                "drawCallback": this.eventos_data_table
            });
            tabla_registros.on( 'responsive-display',  ( e, datatable, row, showHide, update ) => {
                //console.log( 'Details for row '+row.index()+' '+(showHide ? 'shown' : 'hidden') );

                //console.log('ema');
                this.eventos_data_table();
            } );
        },
        eventos_data_table()
        {
            Array.from(document.getElementsByClassName("boton-modal-editar-registro")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_editar_registro_evento);
            });
            
            Array.from(document.getElementsByClassName("boton-modal-remover")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_remover);
            });
        },
        boton_modal_remover(item)
        {
            //this.datos.registro.i
            let dt={
                id:calculos.atributo(item,'registro-id'),
                //no:calculos.atributo(item,'registro-no')
            };
            Swal.fire({
                title: `¿ Remover usuario Id : ${dt.id} ?`,
                text: "",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Si, remover ahora",
                cancelButtonText:'Cancelar'
            }).then((result) => {
                if (result.isConfirmed)
                {
                    this.alerta({titulo:'Procesando datos',mensaje:'espere ...'});  
                    fetch(`${this.general.otros.dominio_server}/usuarios/registro/remover`,{
                        method:'POST',
                        body:JSON.stringify( {
                            id:dt.id,
                        } ),
                        headers:{                    
                            //'X-CSRF-TOKEN':this.general.otros.csrf
                            'Content-Type'  :'application/json',
                            'Accept'        :'application/json',
                            //'Authorization' :`Bearer ${this.general.otros.token}`
                        },
                        credentials: 'include',
                    })
                    //.then(res=>res.json())
                    .then(res => {
                        if (res.status == 200) 
                        {
                            return res.json();
                        }
                        else
                        {
                            throw new Error(`Error: ${res.status}`);
                        }
                    })
                    .then(respuesta=>{
                        let dt={
                            'bien':()=>{                        
                                this.obtener_datos_data_table();
                                //$("#modal-registro").modal("hide");
                                this.funciones({nombre:'alerta',estatus:'success',mensaje:`Usuario removido`});
                            },
                            'no encontrado':()=>{
                                this.obtener_datos_data_table();
                                //$("#modal-registro").modal("hide");
                                this.funciones({nombre:'alerta',estatus:'error',mensaje:`Usuario no encontrado`});
                            }
                        };

                        if(respuesta.mensaje in dt )
                        {
                            dt[respuesta.mensaje]();
                        }                
                    })
                    .catch(error=>{
                        this.funciones({nombre:'alerta',estatus:'error',mensaje:`El usuario no se pudo remover`});
                    })
                    .finally( () => {
                        //this.datos.data_table.cargando=false;
                    });
                }
            });
        },
        boton_modal_editar_registro_evento(item)
        {
            this.boton_modal_registro();
            this.datos.registro.id=item.target.getAttribute('registro-id');
            //fetch(`${this.general.otros.dominio_server}/usuarios/${this.datos.registro.id}/datos`)
            fetch(`${this.general.otros.dominio_server}/usuarios/${this.datos.registro.id}/datos`,{
                method:'GET',
                headers:{
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },
                credentials: 'include',
            })
            .then(res=>res.json())
            .then(respuesta=>{
                //console.log('datos2 :');
                //console.log(respuesta);

                for (const property in this.datos.registro) {
                    //if( ! ['id','password'].includes(property))
                    //{
                        this.datos.registro[property]= property in respuesta.datos[0] ? respuesta.datos[0][property] : this.datos.registro[property];
                    //}
                }

                //console.log('datos 2 son');
                //console.log(this.datos.registro);
            });
        },
        enviar_datos()
        {
            /* if(this.datos.registro.id==='' && this.datos.num_soc.existe=='no')
            {
                this.enviar_datos_peticion();
            }
            else if(this.datos.registro.id!=='')
            { */
                this.enviar_datos_peticion();
            // }
        },
        enviar_datos_peticion()
        {
            this.alerta({titulo:'Procesando datos',mensaje:'espere ...'});
            fetch(`${this.general.otros.dominio_server}/usuarios/registro`,{
                method:'POST',
                body:JSON.stringify( this.datos.registro ),
                headers:{
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },
                credentials: 'include',
            })
            .then(res=>res.json())
            .then(respuesta=>{
                let dt={
                    'bien':()=>{
                        //this.datos.registro.id=respuesta.datos.mantenimientos_id;
                        //this.data_table();
                        this.obtener_datos_data_table();
                        //this.enviar_datos_imagenes();
                        $("#modal-registro").modal("hide");

                        this.funciones({nombre:'alerta',estatus:'success',mensaje:`Usuario ${this.datos.registro.id=='' ? 'creado' : 'editado'}`});
                    },
                    'fallo validacion':()=>{
                        this.funciones({nombre:'alerta',estatus:'error',mensaje:`Correo y contraseña son obligatorios`});
                    }
                };

                if(respuesta.mensaje in dt )
                {
                    dt[respuesta.mensaje]();
                }                
            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`Usuario no pudo crearse`});
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;                
            });
        },
        enviar_datos_imagenes()
        {
            let imagenes=[];
            this.datos.registro.imagenes.forEach((item)=>{
                if( (item.estado=='activo' && item.mantenimientos_imagenes_id==='')  || (item.estado=='inactivo' && item.mantenimientos_imagenes_id!=='') )
                {
                    imagenes.push(
                        {
                            estado                          :item.estado,
                            mantenimientos_imagenes_id      :item.mantenimientos_imagenes_id,
                            archivo                         :item.archivo,
                            mantenimientos_id               :this.datos.registro.id,
                        }
                    );
                }
            });
            this.funciones({nombre:'multiples_peticiones',datos:imagenes,url:'/mantenimientos/registro/imagenes'});
        },
        agregar_pieza()
        {
            //this.funciones({nombre:'sonido',sonido:'sonido-agregar.mp3'})
            this.datos.registro.piezas.push(
                {
                    cantidad:0,
                    descripcion:''
                }
            );
        },
        remover_pieza(pieza_index)
        {
            //this.funciones({nombre:'sonido',sonido:'sonido-remover.mp3'})
            this.datos.registro.piezas.splice(pieza_index,1);
        },
        agregar_imagen()
        {
            this.datos.registro.imagenes.push(
                {
                    estado:'activo',
                    mantenimientos_imagenes_id:'',
                    archivo:'',
                    url:''
                }
            );
            this.funciones(
                {
                    nombre:'cargar_imagen_local',
                    elemento_html:'imagen-mantenimiento',
                    destino:this.datos.registro.imagenes[this.datos.registro.imagenes.length-1]
                }
            );
            //console.log('imagenes');
            //console.log(this.datos.registro.imagenes);
        },
        remover_imagen(imagen_index)
        {
            //this.funciones({nombre:'sonido',sonido:'sonido-remover.mp3'});
            this.datos.registro.imagenes[imagen_index].estado='inactivo';
            //this.datos.registro.imagenes.splice(imagen_index,1);
        },
        verificar_numero_socio()
        {
            if(this.datos.registro.id==='' && this.datos.registro.numero_socio_amcc!=='')
            {
                if(this.datos.num_soc.verificando_num_soc===false)
                {
                    this.datos.num_soc.verificando_num_soc=true;
                    let a=this.datos.registro.numero_socio_amcc;
                    fetch(`${this.general.otros.dominio}/usuarios/verificar_numero_socio`,{
                        method:'POST',
                        body:JSON.stringify( {numero_socio_amcc:this.datos.registro.numero_socio_amcc} ),
                        headers:{
                            'Content-Type':'application/json',
                            'X-CSRF-TOKEN':this.general.otros.csrf
                        }
                    })
                    .then(res=>res.json())
                    .then(respuesta=>{
                        console.log(respuesta)
                        this.datos.num_soc.existe=respuesta.datos.existe;
                        this.datos.num_soc.verificando_num_soc=false;
                        if(a!==this.datos.registro.numero_socio_amcc)
                        {
                            this.verificar_numero_socio();
                        }
                    })
                    .catch(error=>{
                        this.datos.num_soc.verificando_num_soc=false;
                    });
                }
            }
        }            
  },
  computed: {...mapState(['general']) },
    watch: {
        'general.otros.autenticado': function (v) {
            if(v)
            {
                this.inicial();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    body{
    #div-nuevo-cliente{
        width: 100%;
        background: #e8e8e8;
        padding: 1em;
        border-radius: 7px;
        margin-top: 1em;
    }
    #tabla-tratamientos{
        #titulo-total{
            text-align: right;
            font-weight: bold;
            font-size: 1.5em;
        }
        #total-unitario{
            text-align: center;
            font-weight: bold;
            font-size: 1.5em;
        }
        #total-importe{
            text-align: center;
            font-weight: bold;
            font-size: 1.5em;
        }
    }
    /*****Boca*****/
    .boca {
        position: absolute;
        width: 720px;
        /*top: 18%;
        right: -13%;*/
    }
    #image-map{
        width: 100%;
        display: block;
    }
    .abrir-modal {
        width: 100%;
        height: 100%;
    }
    .back-ground {
        background-color: transparent;
        cursor: pointer;
        display: block;
        height: 10.5%;
        overflow: hidden;
        position: absolute;
        transform: rotate(34deg);
        transition: all .2s ease-in-out;
        width: 2.7%;
        z-index: 4;
        -ms-transform: rotate(34deg);
        -webkit-transform: rotate(34deg);
        -webkit-transition: all .2s ease-in-out;
        -o-transition: all .2s ease-in-out;
    }
        
}
</style>

